<template>
  <div id="app" :class="{'small-mode': $store.state.sidebarCollapse || $store.state.appMiniWidth}">
    <template v-if="$route.name === 'Entrance' || $route.name === 'WechatBlank'">
      <router-view></router-view>
    </template>
    <template v-else>
      <div class="app-content">
        <sidebar-component></sidebar-component>
        <header-component></header-component>
        <breadcrumbs-component></breadcrumbs-component>
        <router-view></router-view>
      </div>
    </template>
  </div>
</template>

<script>
  import CommonService from '@/io/common.js';
  import SidebarComponent from '@/components/Sidebar.vue';
  import HeaderComponent from '@/components/Header.vue';
  import BreadcrumbsComponent from '@/components/Breadcrumbs.vue';

  export default {
    name: 'App',
    created() {
      this.initView()();
      window.addEventListener('resize', this.initView(), false);
    },
    watch: {
      '$store.state.isLogin'(newValue, oldValue) {
        if (newValue && !this.$store.state.userInfo) {
          CommonService.userInfo().then(res => {
            this.$store.commit('setUserInfo', res.data);
          }).catch(() => {});
        }
      }
    },
    components: {
      SidebarComponent,
      HeaderComponent,
      BreadcrumbsComponent
    },
    methods: {
      initView() {
        return this.debounce(() => {
          let status = this.$store.state.appMiniWidth;
          let width = 1200;
          this.$store.commit('setAppMiniWidth', document.body.clientWidth <= 1200);
        });
      }
    }
  }
</script>

<style lang="less">
  @import './assets/styles/base.less';
  @import './assets/styles/pace.less';
  @import './assets/styles/sidebar.less';
  @import './assets/styles/el-dropdown.less';
  @import './assets/styles/el-menu.less';
  @import './assets/styles/el-table.less';
  @import './assets/styles/el-form.less';
  @import './assets/styles/el-upload.less';
  @import './assets/styles/el-cascader.less';
  @import './assets/styles/el-select.less';
  @import './assets/styles/el-drawer.less';
  @import './assets/styles/el-image.less';
  @import './assets/styles/el-tag.less';
  @import './assets/styles/el-timeline.less';
  @import './assets/styles/el-loading.less';
  @import './assets/styles/el-button.less';
  @import './assets/styles/el-radio.less';
  @import './assets/styles/el-tree.less';
  @import './assets/styles/el-checkbox.less';
</style>
